/**
 * @generated SignedSource<<67f98b16cca97c233aa62a61b044d978>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type ZnglyInfoPinnedContentType = "LIST" | "NONE" | "SINGLE";
export type ZnglyPrivacyUserConsentLevelEnum = "DISABLED" | "GDPR" | "OPT_OUT";
export type UpdateZnglyInfoInput = {
  address1?: string | null | undefined;
  address2?: string | null | undefined;
  address3?: string | null | undefined;
  backendPrimaryColor?: string | null | undefined;
  backendSecondaryColor?: string | null | undefined;
  bodyDescBoxClr?: string | null | undefined;
  bodyDescBoxTxtClr?: string | null | undefined;
  browserTabTitle?: string | null | undefined;
  catZnglistClr?: string | null | undefined;
  chatbotAgentId?: string | null | undefined;
  chatbotAutoOpen?: string | null | undefined;
  chatbotBorderRadius?: string | null | undefined;
  chatbotBubbleBackground?: string | null | undefined;
  chatbotChatBackground?: string | null | undefined;
  chatbotDatastoreId?: string | null | undefined;
  chatbotDisplayMode?: string | null | undefined;
  chatbotFontColor?: string | null | undefined;
  chatbotFontFamily?: string | null | undefined;
  chatbotPrimaryColor?: string | null | undefined;
  chatbotSendIconColor?: string | null | undefined;
  chatbotTitle?: string | null | undefined;
  chatbotTitlebarBackground?: string | null | undefined;
  chatbotTitlebarFontColor?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  content?: string | null | undefined;
  ctaPrimaryClr?: string | null | undefined;
  ctaPrimaryTxtClr?: string | null | undefined;
  ctaSecondaryClr?: string | null | undefined;
  customSocialLinks?: ReadonlyArray<ZnglyInfo_znglyinfo_CustomSocialLinks_RepeaterInput | null | undefined> | null | undefined;
  dashboardLink?: string | null | undefined;
  date?: string | null | undefined;
  ddBgClr?: string | null | undefined;
  ddPrimaryTxtClr?: string | null | undefined;
  ddSecondaryTxtClr?: string | null | undefined;
  email?: string | null | undefined;
  favicon?: string | null | undefined;
  fontStyle?: string | null | undefined;
  footerAccentClr?: string | null | undefined;
  footerBgClr?: string | null | undefined;
  footerPrimaryTxtClr?: string | null | undefined;
  footerSecondaryTxtClr?: string | null | undefined;
  googleAnalyticsId?: string | null | undefined;
  headerBgClr?: string | null | undefined;
  headerButtons?: ReadonlyArray<ZnglyInfo_znglyinfo_HeaderButtons_RepeaterInput | null | undefined> | null | undefined;
  headerLogo?: string | null | undefined;
  headerLogoLink?: string | null | undefined;
  headerPrimaryAccentClr?: string | null | undefined;
  headerPrimaryTxtClr?: string | null | undefined;
  headerSecondaryAccentClr?: string | null | undefined;
  headerSecondaryTxtClr?: string | null | undefined;
  headerText?: string | null | undefined;
  headerTextConditions?: string | null | undefined;
  homePreviewDescription?: string | null | undefined;
  homePreviewImage?: string | null | undefined;
  hubspotTracker?: string | null | undefined;
  id: string;
  ignoreEditLock?: boolean | null | undefined;
  leadfeederTracker?: string | null | undefined;
  links?: ReadonlyArray<ZnglyInfo_znglyinfo_Links_RepeaterInput | null | undefined> | null | undefined;
  linksTitle?: string | null | undefined;
  menuOrder?: number | null | undefined;
  pagePrimaryAccClr?: string | null | undefined;
  pagePrimaryTxtClr?: string | null | undefined;
  pageSecondaryAccClr?: string | null | undefined;
  pageSecondaryTxtClr?: string | null | undefined;
  password?: string | null | undefined;
  phone1?: string | null | undefined;
  phone2?: string | null | undefined;
  pinning?: ZnglyInfo_znglyinfo_Pinning_GroupInput | null | undefined;
  privacyPolicy?: string | null | undefined;
  privacyPolicyDate?: string | null | undefined;
  privacyPolicyEditing?: string | null | undefined;
  privacyPolicyTitle?: string | null | undefined;
  privacyUserConsentLevel?: ZnglyPrivacyUserConsentLevelEnum | null | undefined;
  pvImages?: ReadonlyArray<ZnglyInfo_znglyinfo_PvImages_RepeaterInput | null | undefined> | null | undefined;
  qrImage?: string | null | undefined;
  qrPrimaryColor?: string | null | undefined;
  qrSecondaryColor?: string | null | undefined;
  readMorePrimaryClr?: string | null | undefined;
  readMorePrimaryTxtClr?: string | null | undefined;
  readMoreSecondaryClr?: string | null | undefined;
  salesforceMid?: string | null | undefined;
  searchImage?: string | null | undefined;
  searchImageAi?: string | null | undefined;
  searchPlaceholder?: string | null | undefined;
  searchPlaceholderAi?: string | null | undefined;
  shareBtnPrimaryClr?: string | null | undefined;
  shareBtnSecondaryClr?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  tawkId?: string | null | undefined;
  title?: string | null | undefined;
  umamiAnalyticsId?: string | null | undefined;
  userMenuBackgroundClr?: string | null | undefined;
  userMenuLinkClr?: string | null | undefined;
  userMenuLinkHoverClr?: string | null | undefined;
  zoomInfoTracker?: string | null | undefined;
};
export type ZnglyInfo_znglyinfo_CustomSocialLinks_RepeaterInput = {
  name?: string | null | undefined;
  url?: string | null | undefined;
};
export type ZnglyInfo_znglyinfo_HeaderButtons_RepeaterInput = {
  bgColor?: string | null | undefined;
  bgHvColor?: string | null | undefined;
  formId?: string | null | undefined;
  name?: string | null | undefined;
  textColor?: string | null | undefined;
  textHvColor?: string | null | undefined;
  url?: string | null | undefined;
};
export type ZnglyInfo_znglyinfo_Links_RepeaterInput = {
  linkName?: string | null | undefined;
  linkUrl?: string | null | undefined;
};
export type ZnglyInfo_znglyinfo_Pinning_GroupInput = {
  pinContentType?: ZnglyInfoPinnedContentType | null | undefined;
  pinnedList?: string | null | undefined;
  pinnedVideo?: string | null | undefined;
};
export type ZnglyInfo_znglyinfo_PvImages_RepeaterInput = {
  image?: string | null | undefined;
};
export type ZnglyInfo_UpdateSettings_Mutation$variables = {
  input: UpdateZnglyInfoInput;
  isAnalytics: boolean;
  isBackend: boolean;
  isChatbot: boolean;
  isFooter: boolean;
  isGlobalStyles: boolean;
  isHeader: boolean;
  isHomepage: boolean;
  isIntegrations: boolean;
  isPage: boolean;
  isPersonalisedVideo: boolean;
  isPrivacy: boolean;
  isQrCode: boolean;
  isSiteSettings: boolean;
};
export type ZnglyInfo_UpdateSettings_Mutation$data = {
  readonly updateZnglyInfo: {
    readonly znglyInfo: {
      readonly id: string;
      readonly znglyInfo: {
        readonly " $fragmentSpreads": FragmentRefs<"analytics_Settings_Fragment" | "backend_Settings_Fragment" | "body_Settings_Fragment" | "chatbot_Settings_Fragment" | "footer_Settings_Fragment" | "globalStyles_Settings_Fragment" | "header_Settings_Fragment" | "homePage_Settings_Fragment" | "integrations_Settings_Fragment" | "personalisedVideo_Settings_Fragment" | "privacyPolicy_Settings_Fragment" | "qrCodeTab_Settings_Fragment" | "siteSettings_Settings_Fragment">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ZnglyInfo_UpdateSettings_Mutation = {
  response: ZnglyInfo_UpdateSettings_Mutation$data;
  variables: ZnglyInfo_UpdateSettings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnalytics"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBackend"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isChatbot"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFooter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGlobalStyles"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHeader"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHomepage"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIntegrations"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPage"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPersonalisedVideo"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacy"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isQrCode"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSiteSettings"
},
v14 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chatbotTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = [
  (v15/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = [
  (v15/*: any*/),
  (v18/*: any*/),
  (v17/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v23 = [
  (v17/*: any*/),
  (v15/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = [
  (v15/*: any*/),
  (v18/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyInfo_UpdateSettings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "UpdateZnglyInfoPayload",
        "kind": "LinkedField",
        "name": "updateZnglyInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo",
                "kind": "LinkedField",
                "name": "znglyInfo",
                "plural": false,
                "selections": [
                  {
                    "condition": "isIntegrations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "integrations_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isAnalytics",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "analytics_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isPrivacy",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "privacyPolicy_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isSiteSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "siteSettings_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isGlobalStyles",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "globalStyles_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isQrCode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "qrCodeTab_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isBackend",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "backend_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isPersonalisedVideo",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "personalisedVideo_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isHeader",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "header_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isPage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "body_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isFooter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "footer_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "homePage_Settings_Fragment"
                      }
                    ]
                  },
                  {
                    "condition": "isChatbot",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chatbot_Settings_Fragment"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ZnglyInfo_UpdateSettings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "UpdateZnglyInfoPayload",
        "kind": "LinkedField",
        "name": "updateZnglyInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo",
                "kind": "LinkedField",
                "name": "znglyInfo",
                "plural": false,
                "selections": [
                  {
                    "condition": "isIntegrations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "salesforceMid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadfeederTracker",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomInfoTracker",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotAgentId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotDatastoreId",
                        "storageKey": null
                      },
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "condition": "isAnalytics",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleAnalyticsId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "umamiAnalyticsId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dashboardLink",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPrivacy",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicyTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicyEditing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicyDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyUserConsentLevel",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isSiteSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "browserTabTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "favicon",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "homePreviewImage",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "homePreviewDescription",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isGlobalStyles",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontStyle",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isQrCode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "qrPrimaryColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "qrSecondaryColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "qrImage",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isBackend",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backendPrimaryColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backendSecondaryColor",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPersonalisedVideo",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyInfo_Znglyinfo_pvImages",
                        "kind": "LinkedField",
                        "name": "pvImages",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaItem",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isHeader",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "headerLogo",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerTextConditions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerLogoLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerSecondaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerSecondaryAccentClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerPrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerPrimaryAccentClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerBgClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userMenuBackgroundClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userMenuLinkClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userMenuLinkHoverClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyInfo_Znglyinfo_headerButtons",
                        "kind": "LinkedField",
                        "name": "headerButtons",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bgColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bgHvColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textHvColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ZnglyInfo_Znglyinfo_headerButtonsToFormConnectionEdge",
                            "kind": "LinkedField",
                            "name": "form",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Form",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "content",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "schema",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uiSchema",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formStyle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formTemplate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cookieExpiration",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "submitSuccessText",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "marketingConsent",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "password",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyInfo_Znglyinfo_customSocialLinks",
                        "kind": "LinkedField",
                        "name": "customSocialLinks",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bodyDescBoxClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bodyDescBoxTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readMorePrimaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readMoreSecondaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readMorePrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaPrimaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaSecondaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaPrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pagePrimaryAccClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pagePrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pageSecondaryAccClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pageSecondaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shareBtnPrimaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shareBtnSecondaryClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "catZnglistClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ddBgClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ddPrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ddSecondaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchPlaceholder",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchPlaceholderAi",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "searchImage",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "searchImageAi",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isFooter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "linksTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyInfo_Znglyinfo_links",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address3",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerAccentClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerBgClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerPrimaryTxtClr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerSecondaryTxtClr",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyInfo_Znglyinfo_Pinning",
                        "kind": "LinkedField",
                        "name": "pinning",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pinContentType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "pinnedList",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "Znglist",
                                "abstractKey": null
                              },
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "pinnedVideo",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "ZnglyVideo",
                                "abstractKey": null
                              },
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isChatbot",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotPrimaryColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotFontFamily",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotFontColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotBubbleBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotTitlebarBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotTitlebarFontColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotChatBackground",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotBorderRadius",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotSendIconColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotAutoOpen",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatbotDisplayMode",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6b4f5a4000bbc9a7fc0f3ed43817e2e",
    "id": null,
    "metadata": {},
    "name": "ZnglyInfo_UpdateSettings_Mutation",
    "operationKind": "mutation",
    "text": "mutation ZnglyInfo_UpdateSettings_Mutation(\n  $input: UpdateZnglyInfoInput!\n  $isIntegrations: Boolean!\n  $isAnalytics: Boolean!\n  $isPrivacy: Boolean!\n  $isSiteSettings: Boolean!\n  $isGlobalStyles: Boolean!\n  $isQrCode: Boolean!\n  $isBackend: Boolean!\n  $isHeader: Boolean!\n  $isPage: Boolean!\n  $isFooter: Boolean!\n  $isHomepage: Boolean!\n  $isPersonalisedVideo: Boolean!\n  $isChatbot: Boolean!\n) {\n  updateZnglyInfo(input: $input) {\n    znglyInfo {\n      id\n      znglyInfo {\n        ...integrations_Settings_Fragment @include(if: $isIntegrations)\n        ...analytics_Settings_Fragment @include(if: $isAnalytics)\n        ...privacyPolicy_Settings_Fragment @include(if: $isPrivacy)\n        ...siteSettings_Settings_Fragment @include(if: $isSiteSettings)\n        ...globalStyles_Settings_Fragment @include(if: $isGlobalStyles)\n        ...qrCodeTab_Settings_Fragment @include(if: $isQrCode)\n        ...backend_Settings_Fragment @include(if: $isBackend)\n        ...personalisedVideo_Settings_Fragment @include(if: $isPersonalisedVideo)\n        ...header_Settings_Fragment @include(if: $isHeader)\n        ...body_Settings_Fragment @include(if: $isPage)\n        ...footer_Settings_Fragment @include(if: $isFooter)\n        ...homePage_Settings_Fragment @include(if: $isHomepage)\n        ...chatbot_Settings_Fragment @include(if: $isChatbot)\n      }\n    }\n  }\n}\n\nfragment analytics_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  googleAnalyticsId\n  umamiAnalyticsId\n  dashboardLink\n}\n\nfragment backend_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  backendPrimaryColor\n  backendSecondaryColor\n}\n\nfragment body_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  bodyDescBoxClr\n  bodyDescBoxTxtClr\n  readMorePrimaryClr\n  readMoreSecondaryClr\n  readMorePrimaryTxtClr\n  ctaPrimaryClr\n  ctaSecondaryClr\n  ctaPrimaryTxtClr\n  pagePrimaryAccClr\n  pagePrimaryTxtClr\n  pageSecondaryAccClr\n  pageSecondaryTxtClr\n  shareBtnPrimaryClr\n  shareBtnSecondaryClr\n  catZnglistClr\n  ddBgClr\n  ddPrimaryTxtClr\n  ddSecondaryTxtClr\n  searchPlaceholder\n  searchPlaceholderAi\n  searchImage {\n    mediaItemUrl\n    id\n  }\n  searchImageAi {\n    mediaItemUrl\n    id\n  }\n}\n\nfragment chatbot_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  chatbotTitle\n  chatbotPrimaryColor\n  chatbotFontFamily\n  chatbotFontColor\n  chatbotBubbleBackground\n  chatbotTitlebarBackground\n  chatbotTitlebarFontColor\n  chatbotChatBackground\n  chatbotBorderRadius\n  chatbotSendIconColor\n  chatbotAutoOpen\n  chatbotDisplayMode\n}\n\nfragment footer_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  linksTitle\n  links {\n    linkName\n    linkUrl\n  }\n  address1\n  address2\n  address3\n  email\n  phone1\n  phone2\n  footerAccentClr\n  footerBgClr\n  footerPrimaryTxtClr\n  footerSecondaryTxtClr\n}\n\nfragment globalStyles_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  fontStyle\n}\n\nfragment header_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  headerLogo {\n    id\n    title\n    mediaItemUrl\n  }\n  headerText\n  headerTextConditions\n  headerLogoLink\n  headerSecondaryTxtClr\n  headerSecondaryAccentClr\n  headerPrimaryTxtClr\n  headerPrimaryAccentClr\n  headerBgClr\n  userMenuBackgroundClr\n  userMenuLinkClr\n  userMenuLinkHoverClr\n  headerButtons {\n    name\n    url\n    bgColor\n    textColor\n    bgHvColor\n    textHvColor\n    formId\n    form {\n      node {\n        id\n        title\n        content\n        schema\n        uiSchema\n        metadata {\n          formStyle\n          formTemplate\n          cookieExpiration\n          submitSuccessText\n        }\n        marketingConsent\n        password\n        imageUrl\n      }\n    }\n  }\n  customSocialLinks {\n    name\n    url\n  }\n}\n\nfragment homePage_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  pinning {\n    pinContentType\n    pinnedList {\n      __typename\n      ... on Znglist {\n        id\n        title\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    pinnedVideo {\n      __typename\n      ... on ZnglyVideo {\n        id\n        title\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment integrations_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  salesforceMid\n  leadfeederTracker\n  zoomInfoTracker\n  chatbotAgentId\n  chatbotDatastoreId\n  chatbotTitle\n}\n\nfragment personalisedVideo_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  pvImages {\n    image {\n      id\n      title\n      mediaItemUrl\n    }\n  }\n}\n\nfragment privacyPolicy_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  privacyPolicy\n  privacyPolicyTitle\n  privacyPolicyEditing\n  privacyPolicyDate\n  privacyUserConsentLevel\n}\n\nfragment qrCodeTab_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  qrPrimaryColor\n  qrSecondaryColor\n  qrImage {\n    id\n    title\n    mediaItemUrl\n  }\n}\n\nfragment siteSettings_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  browserTabTitle\n  favicon {\n    id\n    mediaItemUrl\n    title\n  }\n  homePreviewImage {\n    id\n    mediaItemUrl\n    title\n  }\n  homePreviewDescription\n}\n"
  }
};
})();

(node as any).hash = "70473f924ab4b64dc116afdd1bd0163f";

export default node;
